import moment from 'moment'
import {
  GetIsParticipantAgeValidForCategory,
  GetIsParticipantBornAfterLimit,
  GetIsParticipantBornBeforeLimit,
  GetMaxBirthdateForMinAge,
  GetMinBirthdateForMaxAge
} from './types/getIsParticipantAgeValidForCategory.types'

const MAX_HUMAN_AGE = 122
const MIN_HUMAN_AGE = 0

const getMaxBirthdateForMinAge: GetMaxBirthdateForMinAge = (
  minAge,
  checkoutDate
) => {
  const momentCheckoutDate = checkoutDate ? moment(checkoutDate) : moment()

  return (momentCheckoutDate.subtract((minAge ?? MIN_HUMAN_AGE), 'year'))
}

const getMinBirthdateForMaxAge: GetMinBirthdateForMaxAge = (
  maxAge,
  checkoutDate
) => {
  const momentCheckoutDate = checkoutDate ? moment(checkoutDate) : moment()

  return (momentCheckoutDate.subtract((maxAge ?? MAX_HUMAN_AGE) + 1, 'year').add(1, 'day'))
}

const getIsParticipantBornBeforeLimit: GetIsParticipantBornBeforeLimit = (
  birthdate,
  minBirthdateLimit
) => (
  moment(birthdate).isBefore(moment(minBirthdateLimit))
)

const getIsParticipantBornAfterLimit: GetIsParticipantBornAfterLimit = (
  birthdate,
  maxBirthdateLimit
) => (
  moment(birthdate).isAfter(moment(maxBirthdateLimit))
)

export const getIsParticipantAgeValidForCategory: GetIsParticipantAgeValidForCategory = (
  birthdate,
  { maxAge, minAge },
  checkoutDate
) => (
  !getIsParticipantBornBeforeLimit(birthdate, getMinBirthdateForMaxAge(maxAge, checkoutDate)) &&
  !getIsParticipantBornAfterLimit(birthdate, getMaxBirthdateForMinAge(minAge, checkoutDate))
)
